<template>
</template>

<script>
import {db} from '../utils/firebase'
import firebase from "firebase/app"
import consts from '../utils/consts'

export default {
  props: {
    ttsid: { type: String, required: true },
    uid: { type: String, required: true },
    is_disp_multiple_viewing_global: { type: Boolean, required: true },
    event_page_url: { type: String, required: true },
  },
  data() {
    return {
      canViewingtoken: "",
      myViewingToken: "",
      isFirstWatch: false
    }
  },
  firestore() {
    const roomId = this.ttsid;
    const myId = this.uid;

    (async () => {
      // roomの存在チェック
      const postRefParent = db.collection(consts.EVENT_LIVE_MULTIPLE_VIEWING.PARENT_COLLECTION).doc(roomId)
      const postDocParent = await postRefParent.get()
      if (!postDocParent.exists) {
        // room生成
        await postRefParent.set({roomID: roomId},{merge: true})
      }
      // 同時視聴の存在チェック
      const postRefChild = db.collection(consts.EVENT_LIVE_MULTIPLE_VIEWING.PARENT_COLLECTION).doc(roomId).collection(consts.EVENT_LIVE_MULTIPLE_VIEWING.CHILD_COLLECTTION).doc(myId)
      const postDocChild = await postRefChild.get()
      const viewingDoc = db.collection(consts.EVENT_LIVE_MULTIPLE_VIEWING.PARENT_COLLECTION).doc(roomId).collection(consts.EVENT_LIVE_MULTIPLE_VIEWING.CHILD_COLLECTTION).doc(myId)
      // 同時視聴設定の生成
      await viewingDoc.set({token: this.myViewingToken},{merge: false})
    })()

    return {
      canViewingtoken: db.collection(consts.EVENT_LIVE_MULTIPLE_VIEWING.PARENT_COLLECTION).doc(roomId).collection(consts.EVENT_LIVE_MULTIPLE_VIEWING.CHILD_COLLECTTION).doc(myId)
    }
  },
  created(){
    this.myViewingToken = this.getRandomStr()
  },
  methods: {
    getRandomStr: function () {
      const SOURCE = "abcdefghijklmnopqrstuvwxyz0123456789"
      let result = ''
      for(let i = 0; i < 16; i++){
        result += SOURCE[Math.floor(Math.random() * SOURCE.length)];
      }
      return result
    }
  },
  watch: {
    canViewingtoken: function () {
      if (this.isFirstWatch) {
        if (this.canViewingtoken.token != this.myViewingToken) {
          $('#events-live').remove()
          const link = this.event_page_url
          alert("複数端末での視聴は禁止されています")
          location.href = link
        }
      } else {
        this.isFirstWatch = true
      }
    }
  }
}
</script>


<style scoped>
  @import '../packs/application.css';

</style>
